import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const DisbursedLoanReportTable: React.FC<BaseTablePropsType> = ({
	rows,
}) => {
	const disbursedLoanTableHeaders = [
		"Loan ID",
		"Customer Name",
		"Branch",
		"Loan Officer",
		"Amount Disbursed",
		"Outstanding Balance",
		"End Date",
	];
	return (
		<BaseTable headers={disbursedLoanTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{row?.loanId?.toString().padStart(3, "0")}</TableCell>
							<TableCell>{row?.customerName}</TableCell>
							<TableCell>{row?.branch || "GLOBAL"}</TableCell>
							<TableCell>{row?.loanOfficer}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.amountDisbursed ?? 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.outstandingBalance ?? 0)}
							</TableCell>
							<TableCell>{formatDate(row?.endDate, false)}</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
